import type {State} from 'src/reducers';
import type {EntityType} from 'src/types/ats-entities';
import type {TargetEntityTypeState} from 'src/reducers/target-entity-types';
import type {
  EntityMappingsByEntityType,
  TargetEntity,
} from 'src/types/target-entity-types';
import {createSelector} from 'reselect';
import keyBy from 'lodash/keyBy';

/*
 * Base Selectors
 */
export const selectAllEntityTypes = (state: State): TargetEntityTypeState =>
  state.targetEntityTypes;

export const selectTargetEntityTypes: (state: State) => TargetEntityTypeState =
  createSelector(selectAllEntityTypes, (mappings) => {
    return mappings.filter((mapping) => mapping.standard_entity_type !== null);
  });

export const selectEntityMappingsByEntityType: (
  arg1: State,
) => EntityMappingsByEntityType = createSelector(
  selectAllEntityTypes,
  (mappings) => keyBy(mappings, 'entity_type'),
);

export const selectEntityInfo: (arg1: State, arg2: EntityType) => TargetEntity =
  createSelector(
    selectEntityMappingsByEntityType,
    // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'entityType' implicitly has an 'any' type.
    (_, entityType) => entityType,
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<EntityType, TargetEntity>>'.
    (entityMappings, entityType) => entityMappings[entityType],
  );

export const selectFocusEntity: (
  state: State,
  entityType: string,
) => string | null | undefined = createSelector(
  selectTargetEntityTypes,
  // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'entityType' implicitly has an 'any' type.
  (_, entityType) => entityType,
  (entityTypes, entityType) => {
    const selectedEntityType = (entityTypes ?? []).find(
      (entityTypeItem) => entityTypeItem.entity_type === entityType,
    );
    const focusEntity = selectedEntityType?.display_name;
    return focusEntity;
  },
);

export const selectEntityTypeDisplay: (
  entityType: string,
) => (state: State) => string | null | undefined =
  (entityType) => (state: State) =>
    selectFocusEntity(state, entityType);

export const selectEntityTypeByStandardType: (
  state: State,
  standardEntityType: string,
) => string | null | undefined = createSelector(
  selectTargetEntityTypes,
  // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'standardEntityType' implicitly has an 'any' type.
  (_, standardEntityType) => standardEntityType,
  (entityTypes, standardEntityType) => {
    const selectedEntityType = (entityTypes ?? []).find(
      (entityTypeItem) =>
        entityTypeItem.standard_entity_type === standardEntityType,
    );
    const atsEntityType = selectedEntityType?.entity_type;
    return atsEntityType;
  },
);
